module.exports = __webpack_public_path__ + "static/img/liber-g.25aa9e78.png";